import { createAsyncThunk } from '@reduxjs/toolkit';
import { TApiaFilter, TApiaFilterValue } from '../../../types';
import ApiaApi, { makeApiaUrl } from '../../../api/apiaApi/apiaApi';
import actions from '../../../api/apiaApi/actions';
import { arrayOrArray, noNaN } from '../../../utils/util';
import validationsStore from '../../validation/validationStore';
import { TApiaMetaFilter } from '../types';

type TMetadataFilter = {
  id: string | number;
  title: string;
  type: string;
  value: string | number;
  value2?: string | number;
  metadatatype?: string;
};

type TMetadata = {
  docFreeMetadataAvailable: boolean;
  docFreeEvtMetadataAvailable?: boolean;
  docMetadata: {
    metadata: TMetadataFilter | TMetadataFilter[];
  };
};

export type MetaFiltersResult = {
  fieldId: string;
  newFilters: TApiaMetaFilter[];
  docType?: TApiaFilterValue;
  processInfo?: string;
  allowFreeMeta: boolean;
  allowEnvFreeMeta: boolean;
};

const searchMetaFilters = createAsyncThunk<
  MetaFiltersResult,
  {
    ajaxUrl?: string;
    allowFreeMeta?: boolean;
    docType?: TApiaFilterValue;
    ev?: TApiaFilter;
    fieldId: string;
    processInfo?: string;
    tabId?: number | string;
    parseFilters?: (metafilters: MetaFiltersResult) => MetaFiltersResult;
  }
>('documentsMonitorySlice/searchMetaFilters', async (payload) => {
  validationsStore.unregisterForm('MetadataFilters');
  const response = await ApiaApi.post<TMetadata>(
    makeApiaUrl({
      action: actions.monitor.documents.loadMetadata,
      ajaxUrl:
        payload.ajaxUrl ??
        (payload.ev ? window.listData[payload.fieldId].ajaxUrl : undefined),
      react: true,
      isAjax: true,
      docTypeId: payload.ev ? payload.ev.currentValue : payload.docType ?? null,
      preventAsXmlParameter: true,
      tabId: payload.tabId,
    }),
  );

  const filtersArray: TApiaMetaFilter[] = [];

  arrayOrArray(response?.data?.docMetadata.metadata).forEach((metaFilter) => {
    let filterType:
      | 'number'
      | 'date'
      | 'D'
      | 'S'
      | 'N'
      | 'apiaNumber'
      | undefined =
      metaFilter.type === 'D' ||
      metaFilter.type === 'date' ||
      metaFilter.type === 'S'
        ? metaFilter.type
        : undefined;

    let metaFilterType = '';

    if (typeof metaFilter.type === 'string' && metaFilter.type.length > 0) {
      metaFilterType = metaFilter.type;
    }
    if (metaFilter.type === 'number' || metaFilter.type === 'N') {
      filterType = 'apiaNumber';
    }

    const returnObject: TApiaMetaFilter = {
      id: metaFilter.id,
      currentValue: metaFilter.value,
      title: metaFilter.title,
      type: filterType,
      filterToValue: metaFilter.value2?.toString() ?? undefined,
      isMeta: true,
      metaFilterType,
      metadataType: metaFilter.metadatatype,
    };
    filtersArray.push(returnObject);
  });
  const processData = window.location.href.split('&').find((query) => {
    return query.includes('procTitle=');
  });
  const processInfo = processData?.slice(
    noNaN(processData?.indexOf('=')) + 1,
    processData.length,
  );

  const metaFilters: MetaFiltersResult = {
    newFilters: filtersArray,
    fieldId: payload.fieldId,
    docType: payload.docType,
    processInfo: processInfo ?? '',
    allowFreeMeta: response?.data?.docFreeMetadataAvailable ?? false,
    allowEnvFreeMeta: response?.data?.docFreeEvtMetadataAvailable ?? false,
  };

  return payload.parseFilters?.(metaFilters) || metaFilters;
});

export default searchMetaFilters;
